import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./DetailFabricParatha.css";

/* Key = FabricsParatha ke card ka slug (/fabric/:slug) */
const FABRICS = {
  linen: "Linen Sarees",
  banarasi: "Banarasi Sarees",
  cotton: "Cotton Sarees",
  "tissue-cotton": "Tissue Cotton Sarees",
};

const ph = (label, hex) =>
  `https://placehold.co/600x800/${hex}/fffbf7?text=${encodeURIComponent(label)}`;

/* detailId ho to card click par /launch-product/:detailId khulta hai */
const PRODUCTS = [
  { id: "f-1", fabric: "cotton", name: "Nirvki Cotton Saree", price: 2599, oldPrice: 3199, rating: 5, reviews: 14, image: ph("Nirvki", "b9c3a1"), detailId: "ln-1" },
  { id: "f-2", fabric: "linen", name: "Rinki Bang Linen Saree", price: 2599, oldPrice: 3199, rating: 5, reviews: 9, image: ph("Rinki", "d9a38a"), detailId: "ln-2" },
  { id: "f-3", fabric: "banarasi", name: "Anmol Mehrisol Saree", price: 3299, oldPrice: 4599, rating: 5, reviews: 10, image: ph("Anmol", "7a2f3a"), detailId: "ln-3" },
  { id: "f-4", fabric: "cotton", name: "Leafy Cotton Saree", price: 2599, oldPrice: 3199, rating: 5, reviews: 12, image: ph("Leafy", "1f6b3a"), detailId: "ln-4" },
  { id: "f-5", fabric: "linen", name: "Maaliya Linen Saree", price: 2399, oldPrice: 4100, rating: 5, reviews: 7, image: ph("Maaliya", "5d7a35"), detailId: "ln-5" },
  { id: "f-6", fabric: "cotton", name: "Jamun Cotton Saree", price: 1699, oldPrice: 2499, rating: 5, reviews: 117, image: ph("Jamun", "2a4f9a") },
  { id: "f-7", fabric: "cotton", name: "Bulbule Cotton Saree", price: 3499, oldPrice: 2799, rating: 5, reviews: 26, image: ph("Bulbule", "e8e2d6") },
  { id: "f-8", fabric: "cotton", name: "Star Light Cotton Saree", price: 1699, oldPrice: 2499, rating: 5, reviews: 13, image: ph("Star Light", "1c1c1c") },
  { id: "f-9", fabric: "cotton", name: "Tender Cotton Saree", price: 1699, oldPrice: 2499, rating: 5, reviews: 24, image: ph("Tender", "2f5a34") },
  { id: "f-10", fabric: "cotton", name: "Neeraka Cotton Saree", price: 2599, oldPrice: 3499, rating: 5, reviews: 6, image: ph("Neeraka", "c9a227") },
  { id: "f-11", fabric: "cotton", name: "Aquamarine Cotton Saree", price: 1699, oldPrice: 2499, rating: 5, reviews: 63, image: ph("Aquamarine", "7fc4de") },
  { id: "f-12", fabric: "linen", name: "Bangla Phool Linen Saree", price: 2599, oldPrice: 4100, rating: 5, reviews: 41, image: ph("Bangla Phool", "f2d34a") },
  { id: "f-13", fabric: "cotton", name: "Mallika Cotton Saree", price: 1799, oldPrice: 2499, rating: 5, reviews: 37, image: ph("Mallika", "222222"), sale: true },
  { id: "f-14", fabric: "cotton", name: "Gulaabi Bhola Cotton Saree", price: 1699, oldPrice: 2499, rating: 5, reviews: 12, image: ph("Gulaabi Bhola", "e0a07a") },
  { id: "f-15", fabric: "tissue-cotton", name: "Mustard Cotton Saree", price: 1699, oldPrice: 2499, rating: 5, reviews: 41, image: ph("Mustard", "b09a2e") },
];

const SORT_OPTIONS = [
  { value: "featured", label: "Featured" },
  { value: "price-asc", label: "Price, low to high" },
  { value: "price-desc", label: "Price, high to low" },
  { value: "name-asc", label: "Alphabetically, A-Z" },
];

const FILTER_OPTIONS = [
  { value: "all", label: "All prices" },
  { value: "under-2000", label: "Under Rs. 2,000" },
  { value: "2000-3000", label: "Rs. 2,000 - 3,000" },
  { value: "above-3000", label: "Above Rs. 3,000" },
  { value: "sale", label: "On sale" },
];

const matchesFilter = (p, filter) => {
  switch (filter) {
    case "under-2000":
      return p.price < 2000;
    case "2000-3000":
      return p.price >= 2000 && p.price <= 3000;
    case "above-3000":
      return p.price > 3000;
    case "sale":
      return !!p.sale;
    default:
      return true;
  }
};

const formatPrice = (value) =>
  `Rs. ${Number(value).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/* ---------------------------- ICONS ---------------------------- */
const ChevronDown = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const StarIcon = ({ filled }) => (
  <svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true" fill={filled ? "currentColor" : "none"} stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round">
    <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9L12 16.9l-5.2 2.8 1-5.9-4.3-4.1 5.9-.8L12 3.5z" />
  </svg>
);

const Stars = ({ rating, reviews }) => (
  <div className="detailfabricparatha-rating" aria-label={`Rated ${rating} out of 5`}>
    <span className="detailfabricparatha-stars">
      {[1, 2, 3, 4, 5].map((n) => (
        <StarIcon key={n} filled={n <= Math.round(rating)} />
      ))}
    </span>
    <span className="detailfabricparatha-reviews">({reviews})</span>
  </div>
);

/* Select jisme custom chevron hai (qty box jaisa look) */
const SelectBox = ({ label, value, onChange, options }) => (
  <label className="detailfabricparatha-select">
    <span className="detailfabricparatha-select-label">{label}</span>
    <span className="detailfabricparatha-select-field">
      <select value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <ChevronDown />
    </span>
  </label>
);

/* --------------------------- COMPONENT -------------------------- */
const DetailFabricParatha = () => {
  const { slug } = useParams();
  const [sort, setSort] = useState("featured");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    window.scrollTo(0, 0);
    setSort("featured");
    setFilter("all");
  }, [slug]);

  const title = FABRICS[slug];

  const products = useMemo(() => {
    let list = PRODUCTS.filter((p) => p.fabric === slug);
    if (list.length === 0) list = [...PRODUCTS]; // placeholder: match na mile to sab dikhao

    list = list.filter((p) => matchesFilter(p, filter));

    switch (sort) {
      case "price-asc":
        return [...list].sort((a, b) => a.price - b.price);
      case "price-desc":
        return [...list].sort((a, b) => b.price - a.price);
      case "name-asc":
        return [...list].sort((a, b) => a.name.localeCompare(b.name));
      default:
        return list;
    }
  }, [slug, sort, filter]);

  if (!title) {
    return (
      <section className="detailfabricparatha-section">
        <div className="detailfabricparatha-notfound">
          <h2>Fabric not found</h2>
          <Link to="/" className="detailfabricparatha-back">
            Back to home
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section className="detailfabricparatha-section">
      {/* ---------------- TOP BAR ---------------- */}
      <div className="detailfabricparatha-topbar">
        <div className="detailfabricparatha-headwrap">
          <h1 className="detailfabricparatha-heading">{title}</h1>
          <span className="detailfabricparatha-count">
            {products.length} {products.length === 1 ? "product" : "products"}
          </span>
        </div>

        <div className="detailfabricparatha-toolbar">
          <SelectBox label="Sort by" value={sort} onChange={setSort} options={SORT_OPTIONS} />
          <SelectBox label="Filter" value={filter} onChange={setFilter} options={FILTER_OPTIONS} />
        </div>
      </div>

      {/* ---------------- GRID ---------------- */}
      {products.length === 0 ? (
        <p className="detailfabricparatha-empty">No products match this filter.</p>
      ) : (
        <div className="detailfabricparatha-grid">
          {products.map((p) => {
            const inner = (
              <>
                <div className="detailfabricparatha-imgwrap">
                  {p.sale && <span className="detailfabricparatha-sale">Sale</span>}
                  <img
                    src={p.image}
                    alt={p.name}
                    className="detailfabricparatha-img"
                    loading="lazy"
                    draggable={false}
                  />
                </div>

                <div className="detailfabricparatha-body">
                  <h3 className="detailfabricparatha-name">{p.name}</h3>
                  <p className="detailfabricparatha-price">
                    <span>{formatPrice(p.price)}</span>
                    <s>{formatPrice(p.oldPrice)}</s>
                  </p>
                  <Stars rating={p.rating} reviews={p.reviews} />
                </div>
              </>
            );

            return p.detailId ? (
              <Link key={p.id} to={`/launch-product/${p.detailId}`} className="detailfabricparatha-card">
                {inner}
              </Link>
            ) : (
              <div key={p.id} className="detailfabricparatha-card">
                {inner}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default DetailFabricParatha;